import { useEffect, useMemo, useRef, useState } from "react"
// @ts-expect-error 无类型定义
import TCPlayer from "tcplayer.js"
import "tcplayer.js/dist/tcplayer.min.css"
import { Empty } from "tdesign-react"
import { loadJSFile } from "../utils/download"

export enum PlayerStatus {
  success = "success",
  fail = "fail",
  none = "",
}

type SuperProps = {
  url: string
  style?: React.CSSProperties
  className?: string
  status?: PlayerStatus
  onReady?: (player: any) => void
  ctrlbar?: boolean
}

export default function SuperPlayer(props: SuperProps) {
  const {
    url,
    style,
    className,
    status,
    onReady,
    ctrlbar = true,
  } = useMemo(() => props, [props])
  const player: any = useRef(null)
  const [isReady, setIsReady] = useState(false)

  async function initPlayer() {
    await loadJSFile(
      "https://monitor-1258344699.cos.ap-guangzhou.myqcloud.com/flv.min.js",
    )
    player.current = TCPlayer("player-container-id", {
      autoplay: true,
      language: "zh-CN",
      reportable: false,
      licenseUrl:
        "https://license.vod2.myqcloud.com/license/v2/1258442684_1/v_cube.license",
      controls: ctrlbar,
    })

    onReady?.(player.current)
    setIsReady(true)
  }

  function stopPlayer() {
    if (player.current) {
      try {
        player.current.unload()
      } catch (error) {
        console.log("player stop error", error)
      }
    }
  }

  useEffect(() => {
    if (url && isReady) {
      try {
        player.current.src(url)
      } catch (error) {
        console.log("player play error", error)
      }
    }
    if (!url && isReady) {
      stopPlayer()
    }
  }, [url, isReady])

  useEffect(() => {
    initPlayer()
    return () => {
      if (player.current) {
        try {
          player.current.dispose()
        } catch (error) {
          console.log("player stop error", error)
        }
      }
    }
  }, [])
  return (
    <div style={{ position: "relative", ...style }} className={className}>
      <video
        style={{ width: "100%", height: "100%" }}
        id="player-container-id"
        preload="auto"
        playsInline
      />
      {status && (
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Empty type={status} />
        </div>
      )}
    </div>
  )
}
